import { render, staticRenderFns } from "./FiatBillet.vue?vue&type=template&id=2cadff46"
import script from "./FiatBillet.vue?vue&type=script&lang=js"
export * from "./FiatBillet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports